import { ReactElement } from 'react';

import { useField } from 'react-final-form';

import { ComputeResourceType } from '@cast/shared-types';

import { ResourcesSimulationChart } from './_components/ResourcesSimulationChart';
import { SimulationContainer } from './_components/SimulationContainer';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

const Simulations = () => {
  const cpuDays = useField('vpa.lookbackPeriod.cpu.days').input.value || 0;
  const cpuHours = useField('vpa.lookbackPeriod.cpu.hours').input.value || 0;

  const memoryDays =
    useField('vpa.lookbackPeriod.memory.days').input.value || 0;
  const memoryHours =
    useField('vpa.lookbackPeriod.memory.hours').input.value || 0;

  return (
    <>
      <ResourcesSimulationChart
        testId="lookbackPeriod-simulation-cpu"
        type={ComputeResourceType.CPU}
        seed="scaling-policy-simulation-look-back-period-cpu"
        highlightHours={cpuDays * 24 + cpuHours}
      />
      <ResourcesSimulationChart
        testId="lookbackPeriod-simulation-memory"
        type={ComputeResourceType.MEMORY}
        seed="scaling-policy-simulation-look-back-period-memory"
        highlightHours={memoryDays * 24 + memoryHours}
      />
    </>
  );
};

type Props = {
  lookbackPeriodSettingField: ReactElement;
};
export const LookbackPeriodSettingsContainer = ({
  lookbackPeriodSettingField,
}: Props) => {
  const { title, description, docsLinkKey, simulation } =
    vpaSettingsConstants.lookbackPeriod;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
      bottomContent={
        <SimulationContainer description={simulation.description}>
          <Simulations />
        </SimulationContainer>
      }
    >
      {lookbackPeriodSettingField}
    </VerticalSettingsForm>
  );
};
